export default function authHeader() {
  const user = JSON.parse(localStorage.getItem('user'));
  if (user && user.token) {
    //return { Authorization: 'Token ' + user.token }; // for dJango back-end
    return { 'authorization': 'Bearer ' + user.token };       // for Node.js Express back-end
  } else {
    return {};
  }
}
